/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createShoppingCartFromDiscriminatorValue, serializeShoppingCart, serializeUpdateCartRequest, type ErrorResponse, type InternalErrorResponse, type ShoppingCart, type UpdateCartRequest } from '../../../../models/index.js';
// @ts-ignore
import { CodeRequestBuilderRequestsMetadata, type CodeRequestBuilder } from './code/index.js';
// @ts-ignore
import { CompleteCheckoutRequestBuilderRequestsMetadata, type CompleteCheckoutRequestBuilder } from './completeCheckout/index.js';
// @ts-ignore
import { ItemsRequestBuilderNavigationMetadata, ItemsRequestBuilderRequestsMetadata, type ItemsRequestBuilder } from './items/index.js';
// @ts-ignore
import { LinesRequestBuilderNavigationMetadata, type LinesRequestBuilder } from './lines/index.js';
// @ts-ignore
import { PlaceLinesRequestBuilderRequestsMetadata, type PlaceLinesRequestBuilder } from './placeLines/index.js';
// @ts-ignore
import { PoNumberRequestBuilderRequestsMetadata, type PoNumberRequestBuilder } from './poNumber/index.js';
// @ts-ignore
import { PromotionsRequestBuilderRequestsMetadata, type PromotionsRequestBuilder } from './promotions/index.js';
// @ts-ignore
import { RecallReviewRequestBuilderRequestsMetadata, type RecallReviewRequestBuilder } from './recallReview/index.js';
// @ts-ignore
import { ReceiptToRequestBuilderRequestsMetadata, type ReceiptToRequestBuilder } from './receiptTo/index.js';
// @ts-ignore
import { RefreshPricesRequestBuilderRequestsMetadata, type RefreshPricesRequestBuilder } from './refreshPrices/index.js';
// @ts-ignore
import { ShippingRequestBuilderRequestsMetadata, type ShippingRequestBuilder } from './shipping/index.js';
// @ts-ignore
import { SubmitForReviewRequestBuilderRequestsMetadata, type SubmitForReviewRequestBuilder } from './submitForReview/index.js';
// @ts-ignore
import { type VendorLinesRequestBuilder, VendorLinesRequestBuilderNavigationMetadata, VendorLinesRequestBuilderRequestsMetadata } from './vendorLines/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/carts/{cart-id}/{shoppingCartId}
 */
export interface WithShoppingCartItemRequestBuilder extends BaseRequestBuilder<WithShoppingCartItemRequestBuilder> {
    /**
     * The code property
     */
    get code(): CodeRequestBuilder;
    /**
     * The completeCheckout property
     */
    get completeCheckout(): CompleteCheckoutRequestBuilder;
    /**
     * The items property
     */
    get items(): ItemsRequestBuilder;
    /**
     * The lines property
     */
    get lines(): LinesRequestBuilder;
    /**
     * The placeLines property
     */
    get placeLines(): PlaceLinesRequestBuilder;
    /**
     * The poNumber property
     */
    get poNumber(): PoNumberRequestBuilder;
    /**
     * The promotions property
     */
    get promotions(): PromotionsRequestBuilder;
    /**
     * The recallReview property
     */
    get recallReview(): RecallReviewRequestBuilder;
    /**
     * The receiptTo property
     */
    get receiptTo(): ReceiptToRequestBuilder;
    /**
     * The refreshPrices property
     */
    get refreshPrices(): RefreshPricesRequestBuilder;
    /**
     * The shipping property
     */
    get shipping(): ShippingRequestBuilder;
    /**
     * The submitForReview property
     */
    get submitForReview(): SubmitForReviewRequestBuilder;
    /**
     * The vendorLines property
     */
    get vendorLines(): VendorLinesRequestBuilder;
    /**
     * Update a shopping cart with new information
     * @param body Represents a request to update a shopping cart.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ShoppingCart>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {ErrorResponse} error when the service returns a 409 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateCartRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ShoppingCart | undefined>;
    /**
     * Update a shopping cart with new information
     * @param body Represents a request to update a shopping cart.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateCartRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithShoppingCartItemRequestBuilderUriTemplate = "{+baseurl}/api/carts/{cart%2Did}/{shoppingCartId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithShoppingCartItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithShoppingCartItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    code: {
        requestsMetadata: CodeRequestBuilderRequestsMetadata,
    },
    completeCheckout: {
        requestsMetadata: CompleteCheckoutRequestBuilderRequestsMetadata,
    },
    items: {
        requestsMetadata: ItemsRequestBuilderRequestsMetadata,
        navigationMetadata: ItemsRequestBuilderNavigationMetadata,
    },
    lines: {
        navigationMetadata: LinesRequestBuilderNavigationMetadata,
    },
    placeLines: {
        requestsMetadata: PlaceLinesRequestBuilderRequestsMetadata,
    },
    poNumber: {
        requestsMetadata: PoNumberRequestBuilderRequestsMetadata,
    },
    promotions: {
        requestsMetadata: PromotionsRequestBuilderRequestsMetadata,
    },
    recallReview: {
        requestsMetadata: RecallReviewRequestBuilderRequestsMetadata,
    },
    receiptTo: {
        requestsMetadata: ReceiptToRequestBuilderRequestsMetadata,
    },
    refreshPrices: {
        requestsMetadata: RefreshPricesRequestBuilderRequestsMetadata,
    },
    shipping: {
        requestsMetadata: ShippingRequestBuilderRequestsMetadata,
    },
    submitForReview: {
        requestsMetadata: SubmitForReviewRequestBuilderRequestsMetadata,
    },
    vendorLines: {
        requestsMetadata: VendorLinesRequestBuilderRequestsMetadata,
        navigationMetadata: VendorLinesRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithShoppingCartItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: WithShoppingCartItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createShoppingCartFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateCartRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
